import React, { useState, useEffect } from "react";
import { LinearProgress, Box } from "@material-ui/core";

const increment = 250;

/**
 *
 * @param delay: time in ms for data to re-fetch
 * @param fetching: state of fetching query
 * @param reset: forces a reset of the clock
 */
export const DeterminateDivider = ({ delay, fetching, reset }) => {
  const [localClock, setLocalClock] = useState(0);

  useEffect(() => {
    setLocalClock(0);
  }, [reset]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLocalClock(localClock + increment);
    }, increment);

    return () => clearTimeout(timeout);
  }, [delay, localClock]);

  return (
    <Box marginBottom="1rem" marginTop="0.5rem">
      {fetching ? (
        <LinearProgress variant="query" />
      ) : (
        <LinearProgress
          variant="determinate"
          value={localClock / (delay / 105)}
        />
      )}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LiveMeterGraph/DeterminiteDivider/DeterminiteDivider.js